import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import {createLogger} from 'redux-logger';
import rootReducer from './rootReducer';
import rootSaga from './auth/sagas';

const redactAuthPayload = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const nextPayload = { ...payload };

  if (Object.prototype.hasOwnProperty.call(nextPayload, 'jwt')) {
    nextPayload.jwt = '[REDACTED]';
  }

  if (Object.prototype.hasOwnProperty.call(nextPayload, 'jwtAccessToken')) {
    nextPayload.jwtAccessToken = '[REDACTED]';
  }

  if (Object.prototype.hasOwnProperty.call(nextPayload, 'user')) {
    nextPayload.user = '[REDACTED]';
  }

  return nextPayload;
};

const createSafeLogger = () => createLogger({
  actionTransformer: (action) => ({
    ...action,
    payload: redactAuthPayload(action.payload)
  }),
  stateTransformer: (state) => {
    if (!state || !state.auth) {
      return state;
    }

    return {
      ...state,
      auth: {
        ...state.auth,
        user: state.auth.user ? '[REDACTED]' : state.auth.user,
        jwt: state.auth.jwt ? '[REDACTED]' : state.auth.jwt
      }
    };
  }
});

// const loggerMiddleware = createLogger();
const loggerMiddleware = process.env.NODE_ENV !== 'production' ? createSafeLogger() : null;

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = loggerMiddleware ? [loggerMiddleware, sagaMiddleware] : [sagaMiddleware];
  const store = createStore(
    rootReducer,
    preloadedState,
    // applyMiddleware(loggerMiddleware, sagaMiddleware)
    applyMiddleware(...middlewares)
  );

  sagaMiddleware.run(rootSaga);

  return store;
}
